// @ts-nocheck
import poNumberReducer, {
    GreifCheckoutShippingPagesReducerPONumberActions,
} from "@store/Framework/Store/Greif/Pages/CheckoutShipping/PONumber/PONumberReducer";
import { combineReducers } from "redux";

const checkoutShippingReducers = {
    poNumber: poNumberReducer,
};

export type GreifPagesCheckoutShippingActions = GreifCheckoutShippingPagesReducerPONumberActions;
export default combineReducers(checkoutShippingReducers);
